module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ao-61f3047732bbc232681cc3f615c30c8c.svg";